module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_2.738af05a.png";